export const BUTTON_SIZE = '28px';
export const ICON_SIZE = 16;